import React, { useEffect } from "react";
import {
  useEditor,
  SET_EDIT_FIELD,
  ADD_NEW_VARIABLE,
  DRAG_NEW_VARIABLE,
} from "../../context/editor";

function HandleVariableClic({ onAddVariable, onDropVariable, prevState }) {
  const [editorState, editorDispatch] = useEditor();

  var variable = editorState?.variableToAdd;
  var variableToDrop = editorState?.variableToDrop;
  // if (editorState.variableToAdd && editorState.editorField) {
  //   onAddVariable(variable);
  // }

  if (editorState.variableToAdd && prevState !== null) {
    if (editorState.editorField === true) {
      onAddVariable(variable);
      editorDispatch({
        type: ADD_NEW_VARIABLE,
        data: false,
      });
    }
  }

  useEffect(() => {
    if (editorState.variableToDrop && prevState !== null) {
      if (editorState.editorField === true) {
        onAddVariable(variableToDrop);
        editorDispatch({
          type: DRAG_NEW_VARIABLE,
          data: false,
        });
      }
    }
  }, [editorState.variableToDrop]);

  // if (editorState.variableToDrop && editorState.editorField) {
  //   onDropVariable(variableToDrop);
  //   if (editorState.editorField === true) {
  //     editorDispatch({
  //       type: DRAG_NEW_VARIABLE,
  //       data: false,
  //     });
  //   }
  // }
  // console.log("Hola mundo");

  return null;
}

export default HandleVariableClic;
